import Palette       from "../Palette";
import ActivePalette from "./ActivePalette";
import Undo          from "../../../Lib/Objects/Undo";
import BaseStore     from "../../../App/Data/Store/BaseStore";
import AppDataSource from "../../../App/Data/Source/App/AppDataSource";
import indexWhereId  from "../../../Lib/helpers/indexWhereId";
import User          from "../../User/Store/User";
import getDomain     from "../../../Lib/helpers/getDomain";

export default class Palettes extends BaseStore {

    module = ['Palettes'];

    set(palettes) {
        this.commit('setPalettes', palettes);

        if(palettes.length > 0) {
            new ActivePalette().activate(palettes[0].id, 0);
        }
    }

    reorder(oldIndex, newIndex) {
        this.commit('reorder', { oldIndex, newIndex });
    }


    updatePaletteName(name, paletteId) {
        this.commit('updateName', { paletteId, name });

        window.Broadcast.$emit('sign-up-milestone');
    }

    updateNotes(notes, paletteId) {
        this.commit('updateNotes', { notes, paletteId })
    }

    createPalette() {
        let palette = Object.assign({},new AppDataSource().get()[0]);

        palette = new Palette(palette);

        palette.share_link = this.computeShareLink(palette.share_token);

        this.commit('add', palette);

        window.Broadcast.$emit('sign-up-milestone');

        new ActivePalette().activate(palette.id, 0);
    }

    delete(palette) {
        let activePalette = new ActivePalette();
        let isDeletingOnlyPalette = this.state('palettes').length === 1;
        if(isDeletingOnlyPalette) return;

        let isDeletingActive = activePalette.getPalette().id === palette.id;

        this.commit('removePalette', palette.id);

        new Undo('Palette Deleted')
            .onTimerDone(() => {})
            .onUndo(() => {
                this.commit('add', palette);
                this.commit('reorder', { oldIndex: 0, newIndex: palette.position });
            }).start();

        if(isDeletingActive) {
            activePalette.activate(this.state('palettes')[0].id, 0);
        }
    }

    duplicate(palette) {
        let duplicate = new Palette(new AppDataSource().get()[0]);

        duplicate.swatches = palette.getSwatches();
        duplicate.name = palette.name + ' (copy)';

        duplicate.share_link = this.computeShareLink(duplicate.share_token);

        this.commit('add', duplicate);
        new ActivePalette().activate(duplicate.id, 0);
    }

    computeShareLink(token) {
        let userId = new User().getId();

        let domain = getDomain(window.location.href);

        let share_link = '';

        if(userId) {
            share_link = domain + '/share/' + userId + '/' + token;
        }
        else {
            share_link = domain;
        }

        return share_link
    }

    getPaletteById(id) {
        let palettes = this.state('palettes');
        return palettes[indexWhereId(palettes, id)];
    }

    getPalettes() {
        return this.state('palettes');
    }

}
